export default "__VITE_ASSET__7c10a108__"